import { AxiosError } from "axios";

/**
 * Utility function to process a axios error
 *
 * @param axiosError the axios error object
 * @return a single string error message
 */
export function getAxiosErrorMessage(axiosError: AxiosError): string {
    console.error("getAxiosErrorMessage", axiosError);
    if (axiosError.response && axiosError.response.data) {
        const errorResponse: any = axiosError.response.data;
        if (errorResponse.code && errorResponse.code === "CONCURRENT_MODIFICATION") {
            return "Your changes could not be saved and have been discarded. This is because another user has changed the same details.  Please review the changes and reapply your modification.";
        } else if (errorResponse.messages) {
            return errorResponse.messages.join(" and ");
        } else if (errorResponse.status && errorResponse.message) {
            return `${errorResponse.status}: ${errorResponse.message}`;
        } else {
            return "Unknown Error";
        }
    } else if (axiosError.isAxiosError) {
        return axiosError.message;
    } else if (axiosError.request) {
        return "Timeout waiting for server response.";
    }
    return axiosError.message;
}

export function isUnauthorized(axiosError: AxiosError) {
    return axiosError.response && axiosError.response.status === 401;
}

export const apiOrigin = () => {
    //console.log("apiOrigin", window.location.hostname);
    switch (window.location.hostname) {
        case 'qa-shopify.subtrux-test.net':
            return 'https://qa.subtrux-test.net';
        case 'shopify.subtrux.com':
            return 'https://app.subtrux.com';
        case 'dev-shopify-ui.subtrux-test.net':
            return 'https://dev-shopify.subtrux-test.net';
        case '10.0.2.2': /* Android Emulator */
            return 'http://10.0.2.2:9330';
        case 'localhost':
        case '127.0.0.1':
            return 'http://localhost:9330';
        default:
            return ''
    }
};
